module.exports = __webpack_public_path__ + "static/media/mcts-ai-bib.8cc3eaf4.png";